import React, { PropsWithChildren } from "react";
import { observer } from "mobx-react";
import { injectFromApp } from "../../inject";

interface IModalDialogFooterComponentProps {
    className?: string;
}

@injectFromApp<IModalDialogFooterComponentProps>((stores) => ({}))

@observer
export class ModalDialogFooterComponent extends React.Component<PropsWithChildren<IModalDialogFooterComponentProps>> {
    render() {
        const { props } = this;
        const { children, className } = props;

        return <div className={"modal-dialog-footer " + (className ?? "")}>{children}</div>;
    }
}
